import axios from "axios";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";

export const getAzureAlertRulesApi = async (param, provider) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/alert-policies" : "alerts";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      params: param.params,
    });
    return response;
  } catch (e) {
    toast.error("Failed to fetch alert rules");
    return [];
  }
};
